import config from 'config'
import Cookies from 'js-cookie'

// We've started a pricing experiment on 2019-10-10 where customers who see the website
// for the first time after this date will see the new pricing, and customers before this
// will see the old pricing. This means we need to pass the corrosponding billing version
// into the signup so that the correct plans are configured
export function getPricingVersions() {
  const grooveNavigation = Cookies.get('grooveNavigation', {
    domain: `.${config.appDomain}`,
  })
  const parts = (grooveNavigation || '').split(':')
  const webFirstVisit = parts[6]
  const date = webFirstVisit ? new Date(webFirstVisit) : new Date()
  // FIXME: v9 start date TBD
  const v9StartDate = new Date('2022/02/10')
  if (date.getTime() < v9StartDate.getTime()) {
    return {
      preferred_inbox_billing_version: 'v8',
      preferred_kb_billing_version: 'v4',
    }
  }
  return {
    preferred_inbox_billing_version: 'v13',
    preferred_kb_billing_version: 'v5',
  }
}

export const getMarketingAttribution = () => {
  const value = Cookies.get('grooveNavigation', {
    domain: `.${config.appDomain}`,
  })

  if (value === undefined) return {}

  const data = value.split(':')
  const fields = [
    'blog_first_page_url',
    'blog_first_page_date',
    'blog_last_page_url',
    'blog_last_page_date',
    'blog_articles',
    'website_first_page_url',
    'website_first_page_date',
    'website_last_page_url',
    'website_last_page_date',
    'signup_segment',
    'entrance_segment',
  ]
  const attrs = {}

  fields.forEach((field, index) => {
    if (data[index] !== 'null') attrs[field] = data[index]
  })

  return attrs
}
